
import validateCode from '@/components/validate-code';
import Loading from 'vux/src/components/loading/index.vue'

import fileUpload from '@/components/file-upload';
import selectSupply from '@/components/browse/select-supply';
export default {
name: "supple-infor",
components:{validateCode,Loading,fileUpload,selectSupply},
data(){
return{
uploadUrl:process.env.API_ROOT,
countryList:[],
sexList:[],
supClassifyList:[],
companyInfoForm:{
countryId:null,
validFrom:null,
validTo:null,
supClassify:null,
attachment:{attachFile:[]}
},
companyRules:{
countryId:[
{ required: true, message: '此字段必填', trigger: 'change' }
],
validFrom:[
{ required: true, message: '此字段必填', trigger: 'change' }
],
validTo:[
{ required: true, message: '此字段必填', trigger: 'change' }
],
supClassify:[
{ required: true, message: '此字段必填', trigger: 'change' }
],
attachment:[
{ required: true, message: '此字段必填', trigger: 'change' }
],
},
contactForm:{},
contactRules:{
name:[
{ required: true, message: '此字段必填', trigger: 'change' }
],
gender:[
{ required: true, message: '此字段必填', trigger: 'change' }
],
contactEmail:[
{ required: true, message: '此字段必填', trigger: 'change' },
{ type: 'email', message: '请输入正确的邮箱', trigger: ['blur', 'change']}
],
mobilePhone:[
{ required: true, message: '此字段必填', trigger: 'change' },
],
imageCode:[
{ required: true, message: '此字段必填', trigger: 'change' }
],
},
phoneValid:false,//手机号码校验是否重复
phoneregValid:false,// 是否为手机号码
emailValid:false,//邮件校验是否重复
}
},
props:['verify','step'],
methods:{
changeStep(i){
this.$emit('next',2);
},

getCountryList(){
this.$get('api/country/all?_allow_anonymous=true').then((data) => {
this.countryList = data;
})
},

getSexList(){
this.$get('api/dict-tables/search-with-list?_allow_anonymous=true',{dictCode: 'gender'}).then((data) => {
this.sexList = data.dictItems;
});
},

getSupClassifyList(){
this.$get('api/dict-tables/search-with-list?_allow_anonymous=true',{dictCode: 'supClassify'}).then((data) => {
this.supClassifyList = data.dictItems;
});
},

dataRefresh(){
setTimeout(()=>{
if(this.companyInfoForm.countryId !== this.verify.countryId){
this.companyInfoForm.countryId = this.verify.countryId;
this.$refs.imgCode.getImage();
}
},0)
},

submitRegistInfo(){
if(this.phoneValid){
this.$vux.toast.text('同一手机号不能多次注册，请修改联系人手机号');
return;
}
if(this.phoneregValid) {
this.$vux.toast.text('请输入正确的手机号码');
return;
}
this.$refs['companyInfoForm'].validate((companyValid)=>{
if(companyValid){
if(!(this.companyInfoForm.attachment && this.companyInfoForm.attachment.attachFile&& this.companyInfoForm.attachment.attachFile.length > 0)){
this.$vux.toast.text('请上传营业执照');
return;
}
this.$refs['contactForm'].validate((contactValid)=>{
if(!contactValid){
return false;
}
let obj = {
supBasicInfo:this.verify,
supBillInfo: {
companyNameBill: this.verify.supplierName,
vatCode: this.verify.vatCode
},
supContactList: [this.contactForm],
supQualList: [{attachment:this.companyInfoForm.attachment,validFrom:this.companyInfoForm.validFrom,validTo:this.companyInfoForm.validTo}],
imageCode: this.contactForm.imageCode
};
obj.supBasicInfo["supClassify"]=this.companyInfoForm.supClassify;
if(this.$route.query.inviteCheckKey){
obj.inviteCheckKey = this.$route.query.inviteCheckKey;
}
this.$loadingShow();
this.$post('api/supplier/create-by-supplier?_allow_anonymous=true',obj).then((data) => {
this.$loadingHide();
if (data.status === 'error') {
if (data.msg === 'VALIDATE_CODE_EXPIRED') {
this.$vux.toast.text('验证码过期');
} else {
this.$vux.toast.text('验证码错误');
}
this.$refs.imgCode.getImage();
return;
}
this.$router.push(`/supplier/register-login/${data.checkKey}`);
}).catch(()=>{this.$loadingHide();})
})
}
})
},

phoneFocu(){
this.phoneValid = false;
this.phoneregValid =false
},

phoneBlur(){
let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
if(reg.test(this.contactForm.mobilePhone)){
this.phoneregValid=false;
} else {
this.phoneregValid=true;
}
if(this.contactForm.mobilePhone){
this.$get('api/before-login/check-phone?_allow_anonymous=true',{phone:this.contactForm.mobilePhone}).then((data) => {
if(data && data.quantity!=0){
this.phoneValid=true;
}
})
}
},

emailFocu(){
this.emailValid = false;
},

emailBlur(){
if(this.contactForm.contactEmail){
this.$get('api/before-login/check-email?_allow_anonymous=true',{email:this.contactForm.contactEmail}).then((data) => {
if(data && data.quantity!=0){
this.emailValid = true;
}
})
}
}
},
mounted(){
this.getCountryList();
this.getSexList();
this.getSupClassifyList();
this.$eventHub.$on('sendInviteInfo',(res) =>{
this.$set(this.contactForm,'contactEmail',res.email);
});
},
destroyed() {
this.$eventHub.$off('sendInviteInfo');
}
}



// WEBPACK FOOTER //
// ./src/page/supplier/register/supple-infor.vue